import { ProgressRing } from '@/components/ui/progress-ring/progress-ring';
import { cn } from '@/lib/utils';
import { type AssignedTask, TaskV2 } from '@/models/registry';
import { observer } from 'mobx-react-lite';
import useTasksStats, { useTasksStatsV2 } from './hooks/use-tasks-stats';

const TasksProgressRing = ({
  assignedTasks,
}: {
  assignedTasks: AssignedTask[];
}) => {
  const { completedPercentage } = useTasksStats(assignedTasks);

  return (
    <ProgressRing
      percentage={completedPercentage}
      className={cn('h-3.5 w-3.5')}
      circleClassName={cn({
        'text-gray-500': completedPercentage === 0,
        'text-purple-500': completedPercentage > 0 && completedPercentage < 20,
        'text-blue-500': completedPercentage >= 20 && completedPercentage < 40,
        'text-green-500': completedPercentage >= 40,
      })}
    />
  );
};

export const TasksProgressRingV2 = observer(
  ({ assignedTasks }: { assignedTasks: TaskV2[] }) => {
    const { completedPercentage } = useTasksStatsV2(assignedTasks);

    return (
      <ProgressRing
        percentage={completedPercentage}
        className={cn('h-3.5 w-3.5')}
        circleClassName={cn({
          'text-gray-500': completedPercentage === 0,
          'text-purple-500':
            completedPercentage > 0 && completedPercentage < 20,
          'text-blue-500':
            completedPercentage >= 20 && completedPercentage < 40,
          'text-green-500': completedPercentage >= 40,
        })}
      />
    );
  },
);

export default TasksProgressRing;
